import { getElementAbsolutePos } from '../utils/ui-utils';
var DateTimePicker = /** @class */ (function () {
    function DateTimePicker(options) {
        this.calendar = null;
        this.timePicker = null;
        this.options = options;
        this.render();
    }
    Object.defineProperty(DateTimePicker.prototype, "cssPrefix", {
        get: function () {
            return 'kdtp';
        },
        enumerable: true,
        configurable: true
    });
    DateTimePicker.prototype.setDateTime = function (dateTime) {
        this.currentDateTime = new Date(dateTime);
        if (this.calendar) {
            this.calendar.setDate(this.currentDateTime);
        }
        if (this.timePicker) {
            this.timePicker.setTime(this.currentDateTime);
        }
    };
    DateTimePicker.prototype.getDateTime = function () {
        return new Date(this.currentDateTime);
    };
    DateTimePicker.prototype.render = function () {
        var _this = this;
        if (this.options.showCalendar) {
            this.calendar = this.createCalendar({
                yearRange: this.options.yearRange,
                showDateTimeInput: this.options.showDateTimeInput,
                timePickerIsUsed: this.options.showTimePicker,
                oneClickDateSelection: this.options.oneClickDateSelection,
                onDateChanged: function (date, apply) {
                    _this.currentDateTime = date;
                    if (_this.timePicker) {
                        _this.timePicker.setTime(_this.currentDateTime);
                    }
                    if (_this.options.showTimePicker) {
                        _this.dateTimeChanged();
                    }
                    if (apply) {
                        _this.apply(_this.currentDateTime);
                    }
                }
            });
            if (this.calendar)
                this.calendar.render();
        }
        if (this.options.showTimePicker) {
            this.timePicker = this.createTimePicker({
                onTimeChanged: function (time) {
                    _this.currentDateTime.setHours(time.getHours());
                    _this.currentDateTime.setMinutes(time.getMinutes());
                    if (_this.calendar) {
                        _this.calendar.setDate(_this.currentDateTime);
                    }
                    _this.dateTimeChanged();
                }
            });
            if (this.timePicker)
                this.timePicker.render();
        }
        this.setDateTime(new Date());
    };
    DateTimePicker.prototype.createCalendar = function (options) {
        return null;
    };
    DateTimePicker.prototype.createTimePicker = function (options) {
        return null;
    };
    DateTimePicker.prototype.show = function (anchor) {
        if (this.options.beforeShow) {
            this.options.beforeShow();
        }
        var pos = getElementAbsolutePos(anchor || document.body);
        this.slot.style.top = pos.y + anchor.clientHeight + 'px';
        this.slot.style.left = pos.x + 'px';
    };
    DateTimePicker.prototype.apply = function (date) {
        if (this.options.onApply) {
            this.options.onApply(date);
        }
        this.destroy();
    };
    DateTimePicker.prototype.cancel = function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.destroy();
    };
    DateTimePicker.prototype.destroy = function () {
        if (this.slot && this.slot.parentElement) {
            this.slot.parentElement.removeChild(this.slot);
        }
    };
    DateTimePicker.prototype.dateTimeChanged = function () {
        if (this.options.onDateTimeChanged) {
            this.options.onDateTimeChanged(this.currentDateTime);
        }
    };
    return DateTimePicker;
}());
export { DateTimePicker };
//# sourceMappingURL=date_time_picker.js.map